import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/activity/expense-entry/query/', 'Activities');

tbl.add(new Xtc('creator', 'User').renderSlot('user'))
tbl.add(new Xtc('expense_type', 'Expense Type').renderSlot('expense_type'))
tbl.add(new Xtc('matter', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('category', 'Category').renderSlot('category'))
tbl.add(new Xtc('quantity', 'Quantity').renderSlot('quantity'))
tbl.add(new Xtc('rate', 'Rate(s)').renderSlot('rate'))
tbl.add(new Xtc('amount', 'Total amount').renderSlot('amount'))
tbl.add(new Xtc('date', 'Date').renderSlot('date'))
tbl.add(new Xtc('vendor', 'Vendor').hidden().renderSlot('vendor'))
tbl.add(new Xtc('reference', 'Reference').hidden())
tbl.add(new Xtc('reference', 'Used invoices').renderSlot('used_invoices'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

